import { ExpandMore } from "@mui/icons-material";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Typography,
} from "@mui/material";
import { Fragment, useState } from "react";

import { Timeline } from "./Timeline";

export const OrderTimeLine = ({ order }) => {
	const [expanded, setExpanded] = useState(false);

	const handleChange = (panel) => (_, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Order Status
			</Typography>

			<Timeline order={order} mode={"order"} />
			{order.lines.length > 1 && (
				<Accordion
					expanded={expanded === "panel1"}
					onChange={handleChange("panel1")}
				>
					<AccordionSummary expandIcon={<ExpandMore />}>
						<Typography>{`Line Status (${order.lines.length})`}</Typography>
					</AccordionSummary>
					<AccordionDetails>
						{order.lines.map(({ id, title }, i) => {
							return (
								<Fragment key={id}>
									<Typography variant="h6" gutterBottom>
										{`${title} Status`}
									</Typography>
									<Timeline
										order={order}
										line_id={id}
										mode={"line"}
									/>
								</Fragment>
							);
						})}
					</AccordionDetails>
				</Accordion>
			)}
		</Box>
	);
};
